export default __webpack_public_path__ + "22e973b353c2952ab1459479279fbd90.png";